import { Component, Input, Output, EventEmitter } from '@angular/core';
import {CommonModule} from '@angular/common';
import {BaseButtonComponent} from './base-button.component';

@Component({
  standalone: true,
  imports: [CommonModule, BaseButtonComponent],
  selector: 'app-border-icon-button',
  template: `
    <app-base-button
      [baseClass]="'w-full bg-theme-surface py-3 px-4 rounded-2xl flex items-center justify-between border-2 border-theme-secondarybutton'"
      [disabled]="disabled"
      (onClick)="onClick.emit($event)"
      stateColorScheme="surface"
    >
      <div class="flex justify-center w-full text-theme-secondarybutton">
        <div class="flex flex-row items-center">
          <i class="fas text-lg mr-2" [class]="icon"></i>
          <span class="text-center text-lg font-bold tabular-nums">{{ text }}</span>
          <i class="fas text-lg ml-2" [class]="rightIcon"></i>
        </div>
      </div>
    </app-base-button>
  `
})
export class BorderIconButtonComponent {
  @Input() text: string = 'Action';
  @Input() icon?: string;
  @Input() rightIcon?: string;
  @Input() disabled: boolean = false;
  @Output() onClick = new EventEmitter<MouseEvent>();
}
